//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TalksMap from "@/utils/initMapTalks.js";
import * as maptalks from "maptalks";
import AuditRefuseDialog from "../components/AuditRefuseDialog";
import{workServiceDetail,workServiceAudit} from "@/api/gxInfo";
export default {
  name:"",
  data(){
    return {
      id: "",
      detail:{},
      machineRefList:[],//农机信息
      TalksMapDialog: new TalksMap(),
    }
  },
  components:{
    AuditRefuseDialog
  },
  created(){
    this.id = this.$route.query.id;
    this.getDetail();

  },
  mounted(){
    this.mapInit();
  },
  methods:{
    /**
     * @Author: likk
     * @description: 地图初始化
     * @param {*}
     * @return {*}
     */  
     mapInit(){
      this.TalksMapDialog.init("mapBox", 16);
    },
    /**
     * @Author: likk
     * @description: 向地图上添加自定义标注
     * @param {*}
     * @return {*}
     */      
    addMarkerToMap(lng,lat,address){
      this.TalksMapDialog.map.setCenter({x:lng,y:lat});
      this.pic1Marker = new maptalks.VectorLayer("pic1Marker").addTo(
        this.TalksMapDialog.map
      );
      const marker = new maptalks.Marker(
        [lng,lat],
        {
          symbol: [
            {
              markerFile: require("@/assets/gx/biaozhu_dingwei.png"),
              markerWidth: 22,
              markerHeight: 32,
              markerOpacity: 1,
              // info:{
              //   address
              // }
            },
          ],
        }
      ).addTo(this.pic1Marker);
      // marker.on("click", (e) => {
        // let info = e.target._symbol[0].info;
        let content = `<div style='font-size:14px;color:#323333'>农机位置：${address}</div>`
        marker.setInfoWindow({
          single: false,
          content,
        });
        marker.openInfoWindow();
      // });
      
    },
    /**
     * @Author: likk
     * @description: 获取详情数据
     * @param {*}
     * @return {*}
     */ 
    async getDetail(){
      const { data: { result } } = await workServiceDetail(this.id);
      let { machineRefList, ...detail } = result;
      this.detail = detail;
      this.machineRefList = machineRefList;
      this.addMarkerToMap(result.lng,result.lat,detail.workAddress);
    },
    /**
     * @Author: likk
     * @description: 审核
     * @param {Number} auditStatus 20:通过 30：不通过
     * @param {String} refuseReason 不通过理由 非必传
     * @return {*}
     */     
     handleAudit(auditStatus,refuseReason){
        workServiceAudit({
          auditStatus,
          id:this.id,
          refuseReason
        }).then( () => {
          this.$message.success('审核成功');
          this.$router.go(-1);
        })
      },  
      /**
       * @Author: likk
       * @description: 不通过
       * @param {*}
       * @return {*}
       */
       handleRefuse(){
        this.$refs.refuseDialog.handleVisible(true);
       },            
      /**
       * @Author: likk
       * @description: 不通过原因提交
       * @param {*}
       * @return {*}
       */        
      refuseReasonSubmit(data){
        this.handleAudit(30,data);
      }

  }
}
